import React from 'react';
import Button from '../Button/Button';

type ButtonCommandProps = {
  name: string;
  text: string;
  disabled?: boolean;
  onClick: (callback?: () => void) => void;
  waitText?: string;
  waitValue?: boolean;
  waitOnClick?: boolean;
  additionalClassNames?: string;
  //ref?: LegacyRef<HTMLButtonElement>;
};

export const ButtonCommand = ({
  name,
  text,
  disabled,
  onClick,
  waitText,
  waitValue,
  waitOnClick,
  additionalClassNames //ref
}: ButtonCommandProps): JSX.Element => {
  let classes = 'button button-secondary';

  if (additionalClassNames) {
    classes += ` ${additionalClassNames}`;
  }

  classes += ' cms-btn-command';

  return (
    <Button
      name={name}
      text={text}
      disabled={disabled}
      className={classes}
      onClick={onClick}
      waitValue={waitValue}
      waitText={waitText}
      waitOnClick={waitOnClick}
      //ref={ref}
    />
  );
};
